import React from 'react'
import mainLogo from '../../assets/lovedripp_word.png';
import './footer.css';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

function MainFooter() {

  return (
    <div className="main-footer">
       <div className="footer-section section-1">
          <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <div className="foot-widget">
                        <img src={mainLogo} className="footer-logo" alt="Lovedripp full logo" />
                    </div>
                </div>
                <div className="col-md-8 sub-row row">
                     <div className="col-md-4">
                        <div className="foot-widget">
                            <h4 className="foot-head">Who We Are</h4>
                            <ul className="no-style">
                                <li>
                                    <Link to={"/about"}>About LoveDripp</Link>
                                </li>
                                <li>
                                    <Link to={"/contact-us"}>Contact LoveDripp</Link>
                                </li>
                                <li>
                                    <Link to={"/how-to"}>How to</Link>
                                </li>
                                <li>
                                    <Link to={"/blogs"}>Blogs</Link>
                                </li>
                            </ul>
                        </div>
                     </div>
                     <div className="col-md-3">
                        <div className="foot-widget">
                            <h4 className="foot-head">Our Policies</h4>
                            <ul className="no-style">
                                <li>
                                    <Link to={"/refunds-termination"}>Refund & Termination</Link>
                                </li>
                                <li>
                                    <Link to={"/terms-n-conditions"}>Terms and Conditions</Link>
                                </li>
                                <li>
                                    <Link to={"/privacy-policy"}>Privacy Policy</Link>
                                </li>
                            </ul>
                        </div>
                     </div>
                     <div className="col-md-5">
                        <div className="foot-widget">
                            <h4 className="foot-head">Mission</h4>
                            <div className="foot-message">
                                LoveDripp is dedicated to helping you thrive in your marriage. We provide valuable resources and support for couples, including beautiful ways to celebrate your journey with personalized wedding invitations and memorable anniversary keepsakes.
                            </div>
                        </div>
                     </div>
                </div>
            </div>
          </div>
       </div>
       <div className="footer-section section-2">
          <div className="container">
            <div className="row copy-footer">
                <div className="col-md-6">
                    <div className="copy-inner">
                         Copyright &copy; {new Date().getFullYear()} TSDEVCUT. All rights reserved.
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="copy-socials ">
                        <ul className="no-style">
                            <li><Link to="https://www.facebook.com/LoveDripp/" target="_blank"><FaFacebook /></Link></li>
                            <li><Link to="https://www.instagram.com/lovedripp/" target="_blank"><FaInstagram /></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
       </div>
    </div>
  )
}

export default MainFooter